// Simple client-side action logger (no performance hit)
// Stores last 20 actions in memory only

interface Action {
  action: string
  time: number
  url: string
}

class ActionLogger {
  private actions: Action[] = []
  private maxActions = 20

  log(action: string) {
    this.actions.push({
      action,
      time: Date.now(),
      url: window.location.href,
    })

    // Keep only last 20 actions
    if (this.actions.length > this.maxActions) {
      this.actions.shift()
    }
  }

  getRecentActions() {
    return [...this.actions]
  }

  clear() {
    this.actions = []
  }
}

// Singleton instance
export const actionLogger = new ActionLogger()
